(() => {
  const initMij = (root) => {
    if (!root || root.dataset.mijReady === 'true') return;
    root.dataset.mijReady = 'true';

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.querySelectorAll('video[autoplay]').forEach((video) => {
      video.muted = true;
      const play = video.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
    });

    const setupMotion = () => {
      const register = (elements, stagger = 0) => {
        [...elements].forEach((element, index) => {
          element.dataset.mijReveal = '';
          element.style.setProperty('--mij-delay', `${index * stagger}ms`);
        });
      };

      register(root.querySelectorAll('.mij-craft-video, .mij-bag, .mij-rail'));
      register(root.querySelectorAll('.mij-editorial-card'), 55);
      register(root.querySelectorAll('.mij-wells-story > a'), 55);
      register(root.querySelectorAll('.mij-process > *'), 55);
      root.querySelectorAll('.mij-product-grid').forEach((grid) => register(grid.querySelectorAll('.mij-card'), 55));

      const revealItems = root.querySelectorAll('[data-mij-reveal]');
      root.classList.add('mij-motion-ready');

      if (!('IntersectionObserver' in window)) {
        revealItems.forEach((element) => element.classList.add('is-visible'));
      } else {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.06, rootMargin: '0px 0px -4% 0px' });
        revealItems.forEach((element) => observer.observe(element));
      }

      requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('mij-motion-active')));
    };

    setupMotion();

    root.querySelectorAll('[data-mij-rail]').forEach((rail) => {
      const track = rail.querySelector('[data-mij-track]');
      const prev = rail.querySelector('[data-mij-prev]');
      const next = rail.querySelector('[data-mij-next]');
      if (!track || !prev || !next) return;

      const step = () => {
        const cards = [...track.querySelectorAll('.mij-card')];
        if (!cards.length) return track.clientWidth;
        if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
        return cards[0].getBoundingClientRect().width;
      };

      const update = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      };

      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        track.scrollBy({ left: event.key === 'ArrowLeft' ? -step() : step(), behavior: reduced ? 'auto' : 'smooth' });
      });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-mij-root]').forEach(initMij);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
